module.exports = __webpack_public_path__ + "img/rapid&pcr.299a1034.png";